const isEmpty = activity => {
	// Checking reference media
	if (activity.icon.id !== 0 || activity.icon.status !== '') {
		return false
	}

	// Checking background image
	if ((activity.iconBackground.id !== 0 || activity.iconBackground.status !== '')
		&& activity.iconBackground.type !== 'noimage') {
		return false
	}

	// Checking instructions
	if (activity.instructions.text !== '') {
		return false
	}

	// Checking timer
	if (activity.timer.value !== 0) {
		return false
	}

	return true
}

export {
	isEmpty,
}
